var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagIconsRows({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9031 0.393555H2.10313C1.1625 0.393555 0.375 1.15918 0.375 2.12168V11.9217C0.375 12.8623 1.14063 13.6279 2.10313 13.6279H11.9031C12.8438 13.6279 13.6094 12.8623 13.6094 11.9217V2.0998C13.6094 1.15918 12.8438 0.393555 11.9031 0.393555ZM2.10313 1.35605H11.9031C12.2969 1.35605 12.625 1.68418 12.625 2.0998V3.43418H1.35938V2.0998C1.35938 1.70605 1.70938 1.35605 2.10313 1.35605ZM1.35938 6.51856V4.44043H12.625V6.51856H1.35938ZM12.6469 7.48106V9.55918H1.35938V7.48106H12.6469ZM11.9031 12.6436H2.10313C1.70938 12.6436 1.35938 12.3154 1.35938 11.9217V10.5654H12.625V11.9217C12.6469 12.2936 12.2969 12.6436 11.9031 12.6436Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagIconsRows);
export default __webpack_public_path__ + "static/media/tag-icons-rows.af6f8beda2beda82cfec653b1d156405.svg";
export { ForwardRef as ReactComponent };